import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { useWidgetContext } from '../Widget.hooks'

import { QA_NAME_WIDGET_HEADER_ADD_BTN } from './WidgetHeaderContentActionsAddButton.constants'

import PlusIcon from '../../../icons/plus.svg'

function WidgetHeaderContentActionsAddButton({
  qaName = QA_NAME_WIDGET_HEADER_ADD_BTN,
  tooltipKey = 'Common.WidgetHeaderAddButtonOpenTooltipKey',
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleEnableEditMode, handleToggleExpanded, isExpanded } =
    useWidgetContext()

  function handleClick(event) {
    stopPropagation(event)

    if (!isExpanded) {
      handleToggleExpanded(event)
    }

    handleEnableEditMode()
  }

  return (
    <Button.Flat
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: PlusIcon }}
      height={BUTTON_HEIGHT_32}
      qaName={qaName}
      tooltip={t(tooltipKey)}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default WidgetHeaderContentActionsAddButton
